import { YooKassaPaymentWithEmail } from './ui';

export { YooKassaPaymentWithEmail };
